

import React, {
    useMemo
} from 'react';
import { Link } from "react-router";
import { useQuery } from '@tanstack/react-query';

import * as QUERIES from "../query-functions";
import * as UTILS from "../utils";

import LoadingIndicator from './loading-indicator';
import Logo from '../svg/logo';

const TicketCard = (props) => {

    const formattedDate = useMemo(() => {
        return UTILS.formatDateTime(props.event.instance.start)// Formats to a readable date
    }, [props.event.instance.start])
    
    const { 
        isPending,
        isFetching,
        data: imageData,
    } = useQuery({
        queryKey: ['imageData', props.event.event.id],
        queryFn: () => QUERIES.getEventImage(props.event.event.id),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000
    });

    return (
        <div className='ticket-card'>
            <div className='basket-item__image'>
                {isPending || isFetching ?
                    <LoadingIndicator />
                : imageData ?
                    <div dangerouslySetInnerHTML={{__html: imageData}}></div>
                : 
                    <Logo />
                }
            </div>
            <div className='basket-item__summary instance-event-summary'>
                <h2 className='basket-item__title instance-event-summary__title'>{props.event.event.name}</h2>
                <p className='basket-item__date instance-event-summary__date'>{formattedDate}</p>
                <p className='basket-item__venue instance-event-summary__venue'>{props.event.event.attribute_FestivalKingsStudio}</p>
                {props.type == "upcoming" &&
                    <Link to="/account/orders/tickets" className='btn'>View tickets</Link>
                }
            </div>
        </div>
    );
};

export default TicketCard;
